"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_MULTIPLIER = 1000;
//# sourceMappingURL=base-multiplier.js.map